import React from "react";
import DisabledLineItem from "./DisabledLineItem";

class PortalRoomTypeDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    if (this.props.row.room_types && this.props.row.room_types.length > 0) {
      var roomTypes = this.props.row.room_types.map(function (room_type) {
        if (room_type.status == "disabled") {
          return (
            <DisabledLineItem
              key={room_type.id}
              data={room_type}
              disabledRoomTypes={true}
            />
          );
        } else {
          return (
            <li key={room_type.id}>
              {room_type.name}
              {self.props.row.room
                ? ` - ${I18n.t("room")} ${self.props.row.room.identifier}`
                : ""}
              {self.props.row.pin_code
                ? ` - ${I18n.t("pin_code_is", {
                    pin_code: self.props.row.pin_code,
                  })}`
                : ""}
            </li>
          );
        }
      });

      return <ul style={{ marginBottom: 0 }}>{roomTypes}</ul>;
    } else {
      return null;
    }
  }
}

export default PortalRoomTypeDataType;
